import {
  keyRemovedAction,
  keyUpdatedAction
} from '../../../../redux/actions/local';
import { useDispatch, useSelector } from 'react-redux';
import { getStepFieldValue, getFormValues } from '../utils';
import _ from 'lodash';

const useLocal = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.User);
  const { dataLinks } = useSelector(state => state.DataLinks);
  const removeKey = async ({ step, local }) => {
    dispatch(keyRemovedAction(step.localStoreKeyName));
    _.unset(local, step.localStoreKeyName);
    return {
      message: `key ${step.localStoreKeyName} removed from store`
    };
  };

  const updateKey = async ({
    step,
    local,
    documents,
    selections,
    data,
    params,
    history,
    selectedDocumentId
  }) => {
    let inputValue = step.localStoreKeyValue;

    if (
      ((!step.localStoreKeyValueIsJson &&
        step.localStoreKeyValue?.trim().length === 0) ||
        step.localStoreKeyValueIsJson) &&
      data &&
      !step.localStoreIgnoreInputData
    ) {
      /* use data if it is supplied */
      inputValue = data;
    }

    let value = inputValue;

    /* if data is passed into this step then use that as the value if localStoreKeyValue is empty */
    if (!step.localStoreKeyValueIsJson) {
      value = getStepFieldValue({
        stepField: { value: inputValue },
        selections,
        documents,
        data,
        params,
        user,
        local,
        history,
        dataLinks
      });
    }

    try {
      // allow json to be supplied as a value
      value = JSON.parse(value);
    } catch (err) {
      //na
      //console.error(err);
    }

    if (
      value !== undefined &&
      Object.keys(value).length > 0 &&
      step.localStoreKeyValueIsJson &&
      local !== undefined
    ) {
      const existingObject = _.get(local, step.localStoreKeyName) || {};
      value = {
        ...existingObject,
        ...value
      };
    }

    if (value === '{value}' && selectedDocumentId) {
      value = selectedDocumentId;
    }

    _.set(local, step.localStoreKeyName, value);
    dispatch(keyUpdatedAction(step.localStoreKeyName, value));

    return {
      value,
      message: `key ${step.localStoreKeyName} updated to ${value}`
    };
  };

  const toggleKey = async ({ step, local }) => {
    let value = local[step.localStoreKeyName];
    if (value === undefined) {
      value = true;
    } else if (
      value === 'false' ||
      value === false ||
      value === 0 ||
      value === '0'
    ) {
      value = true;
    } else {
      value = false;
    }

    _.set(local, step.localStoreKeyName, value);
    dispatch(keyUpdatedAction(step.localStoreKeyName, value));

    return {
      message: `key ${step.localStoreKeyName} updated to ${value}`
    };
  };

  const saveFormToLocalStore = async ({ step, local }) => {
    let inputs = getFormValues({ formId: step.formId, returnObject: true });

    if (inputs === undefined || inputs.error) {
      return { error: `no form values found on form with id ${step.formId}` };
    }

    if (
      inputs !== undefined &&
      Object.keys(inputs).length > 0 &&
      local !== undefined
    ) {
      const existingObject = _.get(local, step.localStoreKeyName) || {};
      inputs = {
        ...existingObject,
        ...inputs
      };
    }

    _.set(local, step.localStoreKeyName, inputs);
    dispatch(keyUpdatedAction(step.localStoreKeyName, inputs));

    return {
      message: `formId ${step.formId} saved to ${step.localStoreKeyName}`
    };
  };

  return {
    removeKey,
    updateKey,
    toggleKey,
    saveFormToLocalStore
  };
};

export default useLocal;
